import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useCompanies } from "@/hooks/useCompanies";
import { Loader2 } from "lucide-react";

export default function RoleRedirect() {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const { data: user, isLoading: userLoading } = useCurrentUser();

  const isAdmin = user?.roles?.includes("indiqr-admin") ?? false;
  const needsFallback = isAdmin && !user?.company_id;

  // Fallback: quando o backend ainda não retorna company_id, busca pelo /companies/
  const { data: companies, isLoading: companiesLoading } = useCompanies();

  if (authLoading || userLoading || (needsFallback && companiesLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const roles = user?.roles || [];

  if (roles.includes("indiqr-admin")) {
    const companyId = user?.company_id ?? companies?.[0]?.id;
    if (companyId) return <Navigate to={`/empresas/${companyId}`} replace />;
    return <Navigate to="/aguardando" replace />;
  }
  if (roles.includes("indiqr-influenciador")) return <Navigate to="/conversoes" replace />;
  if (roles.includes("indiqr-vendedor")) return <Navigate to="/vender" replace />;

  // No role — awaiting access
  return <Navigate to="/aguardando" replace />;
}
